import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ee094a4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "fans"
}
const _hoisted_2 = { class: "list" }
const _hoisted_3 = ["src", "onClick"]
const _hoisted_4 = {
  key: 0,
  class: "name"
}
const _hoisted_5 = {
  key: 1,
  class: "name"
}
const _hoisted_6 = {
  key: 2,
  class: "job"
}
const _hoisted_7 = {
  key: 3,
  class: "job"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont" }, "", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "关注TA", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont" }, "", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "相互关注", -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  key: 2,
  class: "all1"
}
const _hoisted_17 = { class: "all" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lack = _resolveComponent("lack")!
  const _component_page_show = _resolveComponent("page-show")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.getFansList.data.list && _ctx.getFansList.data.list.length == 0)
      ? (_openBlock(), _createBlock(_component_lack, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.getFansList.data.list && _ctx.getFansList.data.list.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFansList.data.list, (item, index) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("img", {
                src: _ctx.getImgUrl(item.portrait),
                alt: "",
                onClick: ($event: any) => (_ctx.goUser(index))
              }, null, 8, _hoisted_3),
              (item.company_id == null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(item.username), 1))
                : _createCommentVNode("", true),
              (item.company_id != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(item.company), 1))
                : _createCommentVNode("", true),
              (item.company_id == null)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(item.vocation ? item.vocation : "职业暂未填写"), 1))
                : _createCommentVNode("", true),
              (item.company_id != null)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(item.products), 1))
                : _createCommentVNode("", true),
              (item.each == 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 4,
                    class: "focus",
                    onClick: ($event: any) => (_ctx.dofollow(index, 0))
                  }, _hoisted_11, 8, _hoisted_8))
                : _createCommentVNode("", true),
              (item.each == 1)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 5,
                    class: _normalizeClass(["focus", { button1: _ctx.attention }]),
                    onClick: ($event: any) => (_ctx.dofollow(index, 1))
                  }, _hoisted_15, 10, _hoisted_12))
                : _createCommentVNode("", true)
            ]))
          }), 256))
        ]))
      : _createCommentVNode("", true),
    (_ctx.getFansList.data.list.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, " 共" + _toDisplayString(_ctx.total) + "条,每页显示20条,第" + _toDisplayString(_ctx.fanslist.pageIndex) + "/" + _toDisplayString(Math.ceil(_ctx.total / 20)) + "页 ", 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.getFansList.data.list.length > 1)
      ? (_openBlock(), _createBlock(_component_page_show, {
          key: 3,
          total: _ctx.total,
          pageSize: 20,
          onHandleCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["total", "onHandleCurrentChange"]))
      : _createCommentVNode("", true)
  ], 64))
}